import axios from 'axios'
import {FormikProps} from 'formik'
import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {Select} from '../../Form'
import {ClinicSelectModel} from './models'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    prop: FormikProps<any>
    name?: string
    col?: string
}

export function SearchClinic({prop, name, col = 'col-lg-6'}: Props) {
    const dispatch = useDispatch()
    const [selectItem, setSelectItem] = useState<ClinicSelectModel>()

    async function getSelectData() {
        try {
            const {data} = await axios.get<ClinicSelectModel>('/functions/get-clinics')
            setSelectItem(data)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        getSelectData()
    }, [dispatch])

    return (
        <div className={`col-12 ${col} mb-5`}>
            <Select label='Estabelecimento' name={name || 'clinic_id'} formik={prop}>
                {selectItem?.data.select.map((item) => (
                    <option key={`op-${item.id}`} value={item.id}>
                        {item.nm_fantasy}
                    </option>
                ))}
            </Select>
        </div>
    )
}
